// extracted by mini-css-extract-plugin
module.exports = {"image":"Image_image__TiZEY","imageZoomEnabled":"Image_imageZoomEnabled__tj5Ju"};